var render = function render(){var _vm=this,_c=_vm._self._c;return _c('center',[_c('div',{class:_vm.bannerColor},[_c('h3',[_vm._v("Welcome to the AGATRS "),_c('i',[_vm._v(_vm._s(_vm.websiteEnvironment))]),_vm._v(" Site.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }